import React from "react";
import { Photo } from "./types";
import { AddToCartIcon } from "./vectors/LightBoxCartIcons";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const AddToCartButton = ({
  colorTheme,
  onAddToCart,
  photo
}: {
  colorTheme: string;
  onAddToCart: Function;
  photo: Photo;
}) => {
  return (
    <div
      onClick={e => {
        e.preventDefault();
        onAddToCart(photo);
      }}
      className="btn-rem-cart geo-btn--caps geo-mobile-add-to-cart"
      style={{
        border: `1px solid ${ContrastForegroundUtility.lbFgColor(colorTheme)}`
      }}
    >
      <AddToCartIcon color={ContrastForegroundUtility.lbFgColor(colorTheme)} />
      <span
        style={{
          color: ContrastForegroundUtility.lbFgColor(colorTheme)
        }}
      >
        &nbsp; Add to cart
      </span>
    </div>
  );
};

export default AddToCartButton;
